import apiClient from '../lib/apiClient';

const guestService = {
  initSession(sessionId = '') {
    return apiClient.request('/guest/session/init', {
      method: 'POST',
      auth: false,
      body: JSON.stringify({ session_id: sessionId || undefined })
    });
  },
  getSession(sessionId) {
    return apiClient.request(`/guest/session/${encodeURIComponent(sessionId)}`, { auth: false });
  },
  migrate(sessionId) {
    return apiClient.request('/guest/migrate', {
      method: 'POST',
      body: JSON.stringify({ session_id: sessionId })
    });
  }
};

export default guestService;
